module.exports = __webpack_public_path__ + "static/img/imgyd.31f1637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/imgyd.png
// module id = hzgm
// module chunks = 44